export const activeTabActions = {
  SET: 'active-tab-actions/set'
};
export const cartActions = {
  ADD: 'cart-actions/add',
  CLONE: 'cart-actions/clone',
  REMOVE: 'cart-actions/remove',
  RESET: 'cart-actions/reset',
  SETAMOUNT: 'cart-actions/setamount',
  UPDATE: 'cart-actions/update',
  ADDNOTE: 'cart-actions/addNote'
};

export const blurOnSearchActions = {
  SHOW: 'blurOnSearch/show',
  HIDE: 'blurOnSearch/hide'
}
export const modelConfiguratorActions = {
  ADD: 'model-configurator-actions/add',
  SETAMOUNT: 'model-configurator-actions/setamount',
  RESET: 'model-configurator-actions/reset',
};
export const chartActions = {
  GET: 'chart-actions/get',
  LOAD: 'chart-actions/load',
};
export const configuratorActions = {
  ASSIGN: 'configurator-actions/assign',
  COMPLETE: 'configurator-actions/complete',
  FROMTEMPLATE: 'configurator-actions/fromtemplate',
  HARDRESET: 'configurator-actions/hardreset',
  LOADCOMPLEX: 'configurator-actions/loadcomplex',
  LOADEDFROMMODELCONFIGURATOR: 'configurator-actions/loadedfrommodelconfigurator',
  REMOVEFROMMODELCONFIGURATOR: 'configurator-actions/removefrommodelconfigurator',
  LOADED: 'configurator-actions/loaded',
  REMOVE: 'configurator-actions/remove',
  RESET: 'configurator-actions/reset',
  RESETGROUP: 'configurator-actions/resetgroup',
  PRODUCTCHECK:'configurator-actions/products',
  ProductsRESET:'configurator-actions/productReset'
};

export const currentCartItemActions= {
  SHOW: 'currentCartItemActions/show',
  HIDE: 'currentCartItemActions/hide'
}
export const feasibilityActions = {
  VALIDATE: 'feasibility-actions/validate',
  CHECKFEASIILITY: 'feasibility-actions/checkfeasibility',
  LOAD: 'feasibility-actions/load',
  LOADED: 'feasibility-actions/loaded',
  GETRESULT: 'feasibility-action/result',
  LOADRESULT: 'feasibility-action/loadresult',
  RESET: 'feasibility-action/reset',
  GETCONFIGURATORID: 'feasibility-action/getConfiguratorid'
};
export const exportActions = {
  CUSTOMEXPORT: 'export-actions/customexport',
  EXPORT: 'export-actions/export',
  GET: 'export-actions/get',
  LOAD: 'export-actions/load',
  SELECT: 'export-actions/select'
};
export const helpImagesActions = {
  GET: 'help-images-actions/get',
  LOAD: 'help-images-actions/load'
};
export const hierarchyNodeActions = {
  GET: 'hierarchy-node-actions/get',
  LOAD: 'hierarchy-node-actions/load',
  SETNODE: 'hierarchy-node-actions/setnode'
};
export const identityActions = {
  GET: 'identity-actions/get',
  LOAD: 'identity-actions/load',
  UPDATE: 'identity-actions/update'
};
export const importActions = {
  IMPORT: 'import-actions/import',
  VALIDATE: 'import-actions/validate'
};
export const infoActions = {
  GET: 'info-actions/get',
  LOAD: 'info-actions/load'
};
export const popupActions = {
  HIDEPOPUP: 'popup-actions/hidepopup',
  SETPOPUP: 'popup-actions/setpopup',
  UPDATEPOPUP: 'popup-actions/updatepopup',
};
export const priceActions = {
  CHANGEPRICETYPE: 'price-actions/changepricetype',
  FAILED: 'price-actions/failed',
  LOADING: 'price-actions/loading',
  RETRIEVE: 'price-actions/retrieve',
  RETRIEVED: 'price-actions/retrieved'
};
export const productActions = {
  GET: 'product-actions/get',
  LOAD: 'product-actions/load',
  RESET: 'product-actions/reset'
};
export const repositoryActions = entityName => ( {
  CLEAR: `${ entityName }/clear`,
  DELETE: `${ entityName }/delete`,
  DELETED: `${ entityName }/deleted`,
  FAILED: `${ entityName }/failed`,
  GET: `${ entityName }/get`,
  PUT: `${ entityName }/put`,
  RETRIEVE: `${ entityName }/retrieve`,
  RETRIEVED: `${ entityName }/retrieved`,
  SET: `${ entityName }/set`
} );
export const resourceActions = {
  GET: 'resource-actions/get',
  LOAD: 'resource-actions/load'
};
export const screenActions = {
  RESIZE: 'screen-actions/resize'
};

export const screenSizeActions = {
  RESIZE: 'screenSize-actions/resize'
};

export const searchActions = {
  GETCATEGORIES: 'search-actions/getcategories',
  GETPRODUCTS: 'search-actions/getproducts',
  LOAD: 'search-actions/load',
  RESET: 'search-actions/reset'
};
export const detailedSearchActions = {
  GET: 'detailed-search-actions/get',
  LOAD: 'detailed-search-actions/load'
};
export const selectorActions = {
  INIT: 'selector-actions/init',
  PINITEM: 'selector-actions/pinitem',
  UNPINITEM: 'selector-actions/unpinitem',
  REMOVEPINNEDITEMS:'selector-actions/removepinneditems',
  REMOVEPINNEDFILTER:'selector-actions/removepinnedfilter'
};
export const settingsActions = {
  GET: 'settings-actions/get',
  LOAD: 'settings-actions/load'
};
export const siteSettingsActions = {
  GET: 'site-settings-actions/get',
  LOAD: 'site-settings-actions/load'
};
export const viewSettingsActions = {
  GET: 'view-settings-actions/get',
  LOAD: 'view-settings-actions/load'
};
export const viewsActions = {
  CHANGEVIEW: 'views-actions/changeview'
};
export const analyticsActions = {
  EVENT: 'analytics-actions/event',
  INIT: 'analytics-actions/init',
  INITCOMMON: 'analytics-actions/initcommon',
  PAGEVIEW: 'analytics-actions/pageview',
  SET : 'analytics-actions/set'
};
export const orderCodeActions = {
  FIND: 'order-code-actions/find',
  FOUND: 'order-code-actions/found',
  RETRIEVE: 'order-code-actions/retrieve',
  RETRIEVED: 'order-code-actions/retrieved'
};
export const complexSelectorActions = {
  'SET': 'complex-selector-actions/set',
  'RESET': 'complex-selector-actions/reset'
};
export const superCodeActions ={
  CREATED : 'super-code-actions/created',
  CREATE : 'super-code-actions/created',
  IDENTIFY : 'super-code-actions/identify',
  IDENTIFIED : 'super-code-actions/identified',
  SAVETOSAP : 'super-code-actions/savetosap',
};
export const stockActions ={
  'RETRIEVE': 'stock-actions/retrieve',
  'LOADING': 'stock-actions/loading',
  'RETRIEVED': 'stock-actions/retrieved',
  'FAILED': 'stock-actions/failed'
}
export const apttusActions ={
  SAVE : 'apttus-actions/save',
  EDIT : 'apttus-actions/edit',
  DELETE: 'apttus-actions/delete',
  COPY: 'apttus-actions/copy'
}

export const stockFilterActions ={
  UPDATE : 'stockFilter/update',
  RETRIEVE : 'stockFilter/retrieve'
}

export const mobileViewActions = {
  LISTVIEW: 'view/listView',
  MEDIAVIEW: 'view/mediaView'
}

export const amountActions = {
  SETAMOUNT: 'amount/set'
}

export const mobilePageViewActions = {
  SHOWSEARCH: 'mobilePageView/search',
  SHOWCART: 'mobilePageView/cart',
  SHOWOTHER: 'mobilePageView/other',
  SHOWHOMEPAGE: 'mobilePageView/homePage',
  SHOWSELECTOR: 'mobilePageView/selector',
}

export const showFooterActions = {
  SHOW : 'footer/show',
  HIDE : 'footer/hide'
}

export const showConfigureActions = {
  SHOW : 'Configure/show',
  HIDE : 'Configure/hide',
  LEAVE: 'Configure/leave',
  STAY: 'Configure/stay',
  UPDATE: 'Configure/update'
}

export const flagActions = {
  SHOWSEARCH: 'search/show',
  HIDESEARCH: 'search/hide',
  ENABLEREMOVEMETHODCALL: 'configurator/remove/enable',
  DISABLEREMOVEMETHODCALL: 'configurator/remove/disable',
  ADDING: 'cart/adding',
  NOTADDING: 'cart/notAdding',
  SHOWSEARCHOVERLAY: 'searchOverlay/show',
HIDESEARCHOVERLAY: 'searchOverlay/hide',
  SHOWMOBILESEARCHHEADER: 'mobile/search/header/show',
  HIDEMOBILESEARCHHEADER: 'mobile/search/header/hide',
  IMPORTING: 'import/importing',
  NOTIMPORTING: 'import/notimporting',
  BUSY: 'isBusy/busy',
  NOTBUSY: 'isBusy/notBusy'
}

export const dialogActions = {
  SHOWDIALOG: 'dialog/show',
  CLOSEDIALOG: 'dialog/close'
}

export const mobileItemDetailActions = {
  ADD: 'add/component'
}

export const currentPageActions = {
  SETPAGE: 'set/page'
}
export const filterSelectedActions = {
  FILTERSELECTED: 'filterSelected-actions/filterselected'
};